import { useQuery } from '@tanstack/react-query';
import type { ProductKnowledgeArticleListItem } from '../types';

export default function useProductKnowledgeArticles() {
  return useQuery<ProductKnowledgeArticleListItem[]>({
    queryKey: ['admin', 'product-knowledge'],
  });
}
